import { render, staticRenderFns } from "./TabClueDetail.vue?vue&type=template&id=299a1592&"
import script from "./TabClueDetail.vue?vue&type=script&lang=js&"
export * from "./TabClueDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports